import { useQuery } from '@tanstack/react-query';

import { userService } from '@/services/user.service';

export const useGetAllUsers = (pageNumber: number, pageSize: number) => {
	const { data, isLoading, isError, error, refetch, isPending } = useQuery({
		queryKey: ['user', pageNumber],
		queryFn: () => userService.getAllUsers(pageNumber, pageSize),
	});
	return {
		users: data?.data ?? [],
		totalPages: data?.pageCount,
		isLoading,
		isError,
		userError: error,
		error,
		refetch,
		isPending,
	};
};
